// Libs
import { useContext, useEffect, useState } from "react";
import { createBrowserRouter } from "react-router-dom";

// Core
import { AppContext } from "../core/contexts/AppContext";
import { AuthContext } from "../core/contexts/AuthContext";

// Layouts
import MainLayout from "../core/layouts/MainLayout/MainLayout";

// Pages
import RevisioniPage from "../modules/home/pages/RevisioniPage/RevisioniPage";
import ProtectedRoute from "./ProtectedRoute";

const routesMap = {
    REVISIONI_PAGE: "/",
    TEST_PAGE: "/test",
};

const routerInstance = createBrowserRouter(
    [
        {
            path: "/",
            element: (
                <ProtectedRoute allowedRoles={[""]}>
                    <MainLayout />
                </ProtectedRoute>
            ),
            children: [
                {
                    path: routesMap.REVISIONI_PAGE,
                    element: <RevisioniPage />,
                },
            ],
        },
        
    ],
    { basename: process.env.PUBLIC_URL }
);

const useHeaderRoutes = () => {
    const { isInRole } = useContext(AuthContext);
    const { appText, langForText } = useContext(AppContext);

    const { LAYOUT_TEXT } = appText;
    const [headerRoutesArr, setHeaderRoutesArr] = useState(
        genHeaderRoutesArr()
    );

    // Detect language change in AppContext and react to it.
    useEffect(() => {
        setHeaderRoutesArr(genHeaderRoutesArr());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [langForText]);

    function genHeaderRoutesArr() {
        const headerRoutesArrOtherUser = [
            { type: "nav-link", label: LAYOUT_TEXT.ROUTE_LBL_HOME, path: "/" },
            {
                type: "nav-link",
                label: LAYOUT_TEXT.ROUTE_LBL_NEW_PROCESS,
                path: "/",
            },
        ];

        if (isInRole("")) {
            return headerRoutesArrOtherUser;
        } else{
            return [];
        } 
    }

    return [headerRoutesArr];
};

export { routerInstance, routesMap, useHeaderRoutes };
